<template>
  <div class="totals-chart">
    <highcharts ref="totalsByVendorChart" :options="options" />
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue'
export default {
  name: 'VendorsTotalChart',
  components: {
    highcharts: Chart
  },
  props: {
    transactions: Object
  },
  watch: {
    transactions(newVal) {
      console.log('Updated transactions:', newVal)
      this.$nextTick(() => {
        if (this.$refs.totalsByVendorChart) {
          this.$refs.totalsByVendorChart.updateOptions(this.options)
        }
      })
    }
  },
  computed: {
    options() {
      if (!this.transactions || !this.transactions.length) {
        return { series: [] } // Return an empty series to prevent errors
      }

      const vendorTotals = {}

      // Aggregate totals by vendorName
      this.transactions.forEach(({ total, vendorName }) => {
        const vendor = vendorName?.trim() || 'Unknown Vendor' // Handle null or empty vendors
        if (!vendorTotals[vendor]) vendorTotals[vendor] = 0
        vendorTotals[vendor] += total
      })

      // Convert into Highcharts pie chart format
      const seriesData = Object.entries(vendorTotals).map(([name, y]) => ({ name, y }))

      return {
        chart: { type: 'pie' },
        credits: { enabled: false },
        title: { text: 'Total Transactions by Vendor' },
        tooltip: { pointFormat: '{series.name}: <b>{point.y}</b>' },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y}'
            }
          }
        },
        series: [
          {
            name: 'Transactions',
            colorByPoint: true,
            data: seriesData
          }
        ]
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
